import React, { useEffect, useRef, useState } from "react";
import { RCCAlert, RCCButton, RCCCheckBox, RCCGrid, RCCHierarchicalTree, RCCHookToast, RCCIcon, RCCRefHierarchicalTree, RCCServicesApi, RCCTooltip, toggleExpandedForAll } from "react-common-components";
import LoadingContainer from "src/components/LoadingContainer";
import { useTranslation } from "src/context/Translations/context";
import { standardErrorMessages } from "src/utils/errors";
import { IHierarchySWOT, SWOTHierarchyLevel } from "./interface";
import { TextName } from "./styles";

const HierarchyObjetives: React.FC<IHierarchySWOT> = ({
	mee001Id,
	mea001Id,
	register,
	initialData,
	setValue
}) => {
	const { translate } = useTranslation(); 
	const { addToast } = RCCHookToast();

	const refHierarchicalTree = useRef<RCCRefHierarchicalTree>(null);
	const [hierarchy, setHierarchy] = useState<any[]>([]);
	const [expandAll, setExpandAll] = useState(false);

	const [loading, setLoading] = useState(false);
	const [errorLoading, setErrorLoading] = useState(false);

	const showItens = () => {
		const newitens = toggleExpandedForAll({treeData:[...hierarchy],expanded:!expandAll});	
		setHierarchy(newitens);
		setExpandAll(!expandAll);
	};

	const getHierarchy = async () => {
		try{
			setLoading(true);

			const {data} = await RCCServicesApi.getRequest({
				method: "Strategies/ObjectivesHierarchy",
				urlParameters: {
					mee001Id,
					mea001Id
				}
			});

			setHierarchy(data);
			initialData?.forEach((id) => {
				setValue(`selectedSWOTItens-${id}`,id.toString());
			});
			
			setLoading(false);

		}catch(err){
			standardErrorMessages(err, translate("Erro ao buscar os itens"), addToast);
			setLoading(false);
			setErrorLoading(true);
		}
	};

	useEffect(() => {getHierarchy();}, []);

	return (
		<RCCGrid container item direction="column" style={{ display: "flex", width: "100%", flex: 1}}>
			<LoadingContainer loading={loading} hideContent>
				{errorLoading ? (
					<RCCAlert 
						title={translate("Atenção")}
						description={translate("Erro ao buscar as itens")}
					/>
				) : (
					<>
						{
							hierarchy && hierarchy.length === 0 
								? (<RCCAlert 
									title={translate("Atenção")}
									description={translate("Nenhum resultado encontrado")}
								/>)
								: 
								(
									<>
										<RCCGrid container item>
											<RCCGrid 
												container 
												justifyContent="flex-end"
											>
												<RCCTooltip
													color="grey"
													text={translate("Pesquisar")}
													position="leftEnd"
												>
													<RCCButton 
														color="transparent"
														icon={{
															name: "search",
															color: "var(--default-color-font)",
															size: 16
														}}
														onClick={(e) => {
															e.stopPropagation();
															refHierarchicalTree.current?.toggleSearch();
														}}
													/>
												</RCCTooltip>
												<RCCTooltip
													text={expandAll ? translate("Recolher todos") : translate("Expandir todos")}
													position="leftEnd"
												>
													<RCCButton 
														onClick = {() => {showItens();}}
														icon = {{
															name: expandAll ? "compress" : "expand"
														}}
														layout="isRounded"
														size="md"
													/>
												</RCCTooltip>
											</RCCGrid>
											<div 
												style={{ width: "100%" }}
											>
												<RCCHierarchicalTree
													ref={refHierarchicalTree}
													data={hierarchy}
													styleInline="width: 100% !important; .rst__tree{ height: 100%;}  "
													onChange={(treeData) => setHierarchy(treeData)}
													isSearchable={{
														searchKeyOfNode: "name",
														placeholderInput: translate("Pesquisar")
													}}
													customNode={({
														node
													}) => (
														<RCCGrid 
															container
															item
															alignItems="center"
															styleInline={`color:${node.color}`}
														>
															{
																node.level === SWOTHierarchyLevel.ITEM ? (
																	<RCCCheckBox 
																		styleInline={{checkbox: "margin-right: 5px;"}}
																		name={`selectedSWOTItens-${node.id}`} 
																		register={register} 
																		value={node.id}
																	/>
																) : null
															}
															<RCCGrid 
																container
																item
																alignItems="center"
																xs={11}
															>
																{
																	node.level !== SWOTHierarchyLevel.ITEM &&
																<RCCIcon 
																	name={node.level===SWOTHierarchyLevel.SECTION ? "cube":"squares"} 
																	style={{ marginRight: "5px", marginLeft: "5px", color: "var(--input-font-color)" }} 
																/>
																}
																<TextName>{node.name}</TextName>
															</RCCGrid>
														</RCCGrid>
													)}
													canDrop={() => false}
													canDrag={() => false}
													rowHeight={50}
												/>
											</div>
										</RCCGrid>
									</>
								)
						}
					</>
				)}
			</LoadingContainer>
		</RCCGrid>
	);
};

export default HierarchyObjetives;
